export default "__VITE_ASSET__DMzPqiI7__"